export default ({payload, next}) => {
  const {
    obj: {event}
  } = payload

  if (event === 'Lead Triggered') {
    payload.obj.properties.ga_lead_triggered = 1
  }

  next(payload)
}
